import React, { Component } from "react";
import "./DeleteExitModal.css";
import InfoIcon from './InfoIcon'
import {
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

export default class DeleteExitModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleChange = (e) => {
    let { name, value } = e.target;
    const activeItem = { ...this.state.activeItem, [name]: value };
    this.setState({ activeItem });
  };
  render() {
    const { toggle, item, onSave } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={toggle}>
        <ModalHeader>
          {" "}
          Unassign Gateway{" "}
          <button className="exit_close_button" onClick={toggle}>
            ×
          </button>
        </ModalHeader>
        <ModalBody>
          Are you sure you want to unassign the gateway of node{' '}
          {item.map((row) => row.original)[0].eid}{'?'}
          <InfoIcon infoText={"This will move node " + item.map((row) => row.original)[0].eid + " back to the network level of its current gateway."} position={"left"}/>
          <div className="button_area">
            <button className="cancel_button" onClick={toggle}>
              Cancel
            </button>
            <button
              className="delete_button"
              disabled={this.state.loading}
              onClick={() => {
                this.setState({ loading: true });
                onSave(item.map((row) => row.original)[0]);
              }}
            >
              {this.state.loading ? "Loading..." : "Unassign"}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
